import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnChanges {
  @Input() Mensaje: string = '';
  @Input() isVisible: boolean = false;
  @Output() visibilityChange = new EventEmitter<boolean>();

  clic : number = 0;
  onClick = (): void => {
    this.clic++;
    if (this.clic > 1) {
      this.visibilityChange.emit(false);
      this.clic = 0;
    }
  }

  constructor() {
  }

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible']) {
      if (this.isVisible) {
        document.addEventListener('click', this.onClick);
      } else {
        this.clic = 0;
        document.removeEventListener('click', this.onClick);
      }
    }
  }

}
